import { Breadcrumb, Container } from "react-bootstrap";
import clsx from "classnames";
import classes from "./styles.module.scss";
import { getRoute } from "@/functions/getRoute";

export const BreadcrumbNavigation = ({ className, items }) => {
  return (
    <div className={clsx(className, classes.breadcrumbs)}>
      <Container className="mw-xxl">
        <Breadcrumb>
          <Breadcrumb.Item href={getRoute("home")}>Home</Breadcrumb.Item>
          {items.map(({ label, href }, k) => (
            <Breadcrumb.Item key={k} href={href}>
              {label}
            </Breadcrumb.Item>
          ))}
        </Breadcrumb>
      </Container>
    </div>
  );
}

export default BreadcrumbNavigation;